import {EVENT_TYPE} from "./constants";
import {utcToZonedTime } from "date-fns-tz";
import {clearCopiedFieldForEvents, copyHours, parseDate, replaceOrAppendDate} from "./calendars/bryntum_helpers";
import {DateHelper} from "@bryntum/scheduler/scheduler.umd";


export const isExists = (value) => value !== undefined && value !== null
export const isNotNull = (value) =>  value !== null

export const allExists = (...values) => values.every(isExists)

export const isBoolean = (value) =>
    isExists(value)
    && typeof value === "boolean"

export const isObject = (value) =>
    isExists(value)
    && typeof value === "object"

export const isString = (value) =>
    isExists(value)
    && typeof value === "string"

export const propertyExists = (object, key) =>
    allExists(object, key)
    && isObject(object)
    && isString(key)
    && object.hasOwnProperty(key)
    && isExists(object[key])

export const propertyIsArray = (object, key) =>
    propertyExists(object, key)
    && Array.isArray(object[key])

export const propertyIsBoolean = (object, key) =>
    propertyExists(object, key)
    && isBoolean(object[key])

export const propertyIsObject = (object, key) =>
    propertyExists(object, key)
    && isObject(object[key])

export const isInstanceOf = (value, clazz) =>
    allExists(value, clazz)
    && value instanceof clazz

export const isEmptyArray = (value) =>
    Array.isArray(value)
    && value.length === 0

export const hasText = (value) =>
    isString(value)
    && value.trim().length > 0

export const isDevelopment = () => !process.env.NODE_ENV || process.env.NODE_ENV === "development"

export const isLocal = () => window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"

export const setHoursForEventDates = (eventRecord, hours, endHours) => {
    eventRecord.startDate = new Date(eventRecord.startDate.setHours(hours));
    eventRecord.endDate = new Date(eventRecord.endDate.setHours(endHours==undefined?0:endHours));
}

export const decodeBase64 = (encodedStr) => {
    return Buffer.from(encodedStr, 'base64').toString()
}

export const setFeaturingType = (eventRecord) => {
    if (decodeBase64(eventRecord.resourceId) === 'Featuring') {
        eventRecord.type = 'featuring'
    }
}


export const getEventName = (eventRecord) => {
    if (eventRecord.type === undefined ||
        eventRecord.type === null ||
        eventRecord.type.trim() === "" ||
        eventRecord.type !== EVENT_TYPE.AB_TEST)
    {
        if (eventRecord.autorun !== undefined && eventRecord.autorun !== null && eventRecord.autorun) {
            return "&#128260; "  + eventRecord.name;
        } else {
            return eventRecord.name;
        }
    }

    if (eventRecord.type === EVENT_TYPE.AB_TEST) {
        if (!eventRecord.isQACompleted && checkEventIsStarted(eventRecord)) {
            return "&#128205; " + eventRecord.name;
        }
    }
    return eventRecord.name;
}

export const checkEventIsStarted = (eventRecord) => {
    if (eventRecord.startDate === undefined ||
        eventRecord.startDate === null) return false;

    let startDate = new Date(eventRecord.startDate);
    return startDate <= new Date();


}

export function getDateInServerTimeZone(date) {
    if (date !== null) {
        const timeZone = new window.Intl.DateTimeFormat().resolvedOptions().timeZone;
        return utcToZonedTime(date, timeZone);
    } else {
        return new Date();
    }
}


export const getEventIdFromParam = (searchParam) => {
    if (!searchParam) return null;
    if (searchParam.get('event') != null) {
        return searchParam.get('event')
    }
    return null;
}


export const doUseTime = (params) => {
    return params.eventRecord.type === EVENT_TYPE.EVENT ||
        //props.eventRecord.type === EVENT_TYPE.RELEASE ||
        params.eventRecord.type === EVENT_TYPE.MATCH3 ||
        params.eventRecord.type === EVENT_TYPE.ASO ||
        params.eventRecord.type === EVENT_TYPE.AB_TEST ||
        params.eventRecord.type === EVENT_TYPE.AB_TEST_COMMENT;
}

export const beforeCopyEvent = (event) => {
    clearCopiedFieldForEvents(event.source.eventStore)
    let disabledEvent = event.records.find(record => [EVENT_TYPE.ASO, EVENT_TYPE.OFFER, EVENT_TYPE.PROMO].includes(record.type));
    if (isExists(disabledEvent)) {
        return false;
    } else {
        event.records.forEach(record => {
            record.isCopied = true
            record.originalID = record.id
            record.copiedTime = DateHelper.get(record.startDate, 'h')
            record.useTimeInStartDate = doUseTime({eventRecord: record})
            record.useTimeInEndDate = doUseTime({eventRecord: record})

        })
        return true
    }
}

export const fixEventDates = (
    eventRecord,
    originalStart,
    originalEnd
) => {

    const originalStartDay = DateHelper.get(originalStart, "d");
    const originalEndDay = DateHelper.get(originalEnd, "d");
    const originalDuration = DateHelper.diff(originalStart, originalEnd, 'd');

    const newStartDay = DateHelper.get(eventRecord.startDate, "d")
    const newEndDay = DateHelper.get(eventRecord.endDate, "d")


    eventRecord.useTimeInStartDate = doUseTime({eventRecord: eventRecord})
    eventRecord.useTimeInEndDate = doUseTime({eventRecord: eventRecord})

    if(eventRecord.type === EVENT_TYPE.EVENT) {
        eventRecord.name = replaceOrAppendDate(eventRecord)
    }

    if (originalStart.getHours() > originalEnd.getHours()) {
        eventRecord.endDate = DateHelper.add(eventRecord.startDate, eventRecord.duration, 'd');

    }

    if(eventRecord.midDate !== null && eventRecord.midDate !== undefined) {
        const  t = DateHelper.diff(new Date(originalStart), new Date(eventRecord.midDate), 'd')
        eventRecord.midDate = DateHelper.add(eventRecord.startDate, t, 'd');
    }

    if (originalStartDay !== newStartDay && originalEndDay != newEndDay) {
        eventRecord.startDate = copyHours(eventRecord.startDate, originalStart)
        eventRecord.endDate = DateHelper.add(eventRecord.startDate, originalDuration, 'd')
        eventRecord.endDate = copyHours(eventRecord.endDate, originalEnd)
        
        //DateHelper.copyTimeValues(eventRecord.startDate, originalStart)
        //DateHelper.copyTimeValues(eventRecord.endDate, originalEnd)
    }
    eventRecord.duration = DateHelper.diff(eventRecord.startDate, eventRecord.endDate, 'd');

}

export const fixEventId = (eventRecord, startDate) => {
    const EVENT_ID_START_PATTERN = /^\d{8}/;
    const EVENT_ID_LENGTH = 8;
    const inputString = eventRecord.data.eventId;
    const dateStr = parseDate(startDate);

    if (EVENT_ID_START_PATTERN.test(inputString)) {
        const remainingStr = inputString.substring(EVENT_ID_LENGTH);
        eventRecord.data.eventId = dateStr + remainingStr;
    } else {
        eventRecord.data.eventId = dateStr + "_";
    }
}